import { eventType, type default as EventType } from "./EventType";
import type { ColumnType, Selectable, Insertable, Updateable } from "kysely";
import { z } from "zod";

/** Identifier type for events */
export type EventsId = string & { __flavor: "EventsId" };

/**
 * Represents the table public.events
 * @uniqueConstraints {"events_pkey":{"name":"events_pkey","isPrimary":true,"isUnique":true,"columns":[{"name":"id","definition":"id","predicate":null}]},"e_ix_event_type":{"name":"e_ix_event_type","isPrimary":false,"isUnique":false,"columns":[{"name":"event_type","definition":"event_type","predicate":null}]},"e_ix_created_at":{"name":"e_ix_created_at","isPrimary":false,"isUnique":false,"columns":[{"name":"created_at","definition":"created_at","predicate":null}]},"e_ix_is_processed":{"name":"e_ix_is_processed","isPrimary":false,"isUnique":false,"columns":[{"name":"is_processed","definition":"is_processed","predicate":null}]}}
 */
export default interface EventsTable {
  id: ColumnType<EventsId, EventsId | undefined, EventsId>;

  eventType: ColumnType<EventType, EventType, EventType>;

  payload: ColumnType<unknown, unknown, unknown>;

  createdAt: ColumnType<Date, Date | string | undefined, Date | string>;

  isProcessed: ColumnType<boolean, boolean | undefined, boolean>;
}

export type Events = Selectable<EventsTable>;

export type NewEvents = Insertable<EventsTable>;

export type EventsUpdate = Updateable<EventsTable>;

export const eventsId = z.string() as unknown as z.Schema<EventsId>;

export const events = z.object({
  id: eventsId,
  eventType: eventType,
  payload: z.unknown(),
  createdAt: z.date(),
  isProcessed: z.boolean(),
});

export const eventsInitializer = z.object({
  id: eventsId.optional(),
  eventType: eventType,
  payload: z.unknown(),
  createdAt: z.date().optional(),
  isProcessed: z.boolean().optional(),
});

export const eventsMutator = z.object({
  id: eventsId.optional(),
  eventType: eventType.optional(),
  payload: z.unknown().optional(),
  createdAt: z.date().optional(),
  isProcessed: z.boolean().optional(),
});

// ── constraints for Events ─────────────────────────────────
export const EventsConstraints = {
  events_pkey: {
    name: "events_pkey",
    isPrimary: true,
    isUnique: true,
    columns: [{ name: "id", definition: "id", predicate: null }],
  },
  e_ix_event_type: {
    name: "e_ix_event_type",
    isPrimary: false,
    isUnique: false,
    columns: [{ name: "event_type", definition: "event_type", predicate: null }],
  },
  e_ix_created_at: {
    name: "e_ix_created_at",
    isPrimary: false,
    isUnique: false,
    columns: [{ name: "created_at", definition: "created_at", predicate: null }],
  },
  e_ix_is_processed: {
    name: "e_ix_is_processed",
    isPrimary: false,
    isUnique: false,
    columns: [{ name: "is_processed", definition: "is_processed", predicate: null }],
  },
} as const;
export type EventsConstraintsType = typeof EventsConstraints;
